import React from 'react';
import '../../styles/style.css'

function TodosLoading(){
    return(
        <div class="loader"></div>
    );   
}
export {TodosLoading};